import React from "react";

import style from "./style.module.css";

export default function Text ({text, className = ""}) {
    return (
        <div className={`${style[className]}`}>{text}</div>
    )
}